import { lazy } from 'react';
var LLMarkdown = lazy(function () { return import('markdown-to-jsx'); });
export default LLMarkdown;
